import { Link } from "react-router-dom";

export interface LegalBlock {
  type: "h2" | "h3" | "p" | "li";
  text: string;
}

interface LegalPageProps {
  title: string;
  blocks: LegalBlock[];
}

export default function LegalPage({ title, blocks }: LegalPageProps) {
  // Group consecutive list items so they render as a single bulleted list.
  const rendered: JSX.Element[] = [];
  let listBuffer: string[] = [];

  const flushList = (key: string) => {
    if (listBuffer.length === 0) return;
    rendered.push(
      <ul key={key} className="list-disc space-y-1 pl-6">
        {listBuffer.map((text, i) => (
          <li key={i}>{text}</li>
        ))}
      </ul>,
    );
    listBuffer = [];
  };

  blocks.forEach((block, i) => {
    if (block.type === "li") {
      listBuffer.push(block.text);
      return;
    }
    flushList(`list-${i}`);
    if (block.type === "h2") {
      rendered.push(
        <h2 key={i} className="pt-6 text-xl font-semibold">
          {block.text}
        </h2>,
      );
    } else if (block.type === "h3") {
      rendered.push(
        <h3 key={i} className="pt-2 text-base font-semibold">
          {block.text}
        </h3>,
      );
    } else {
      rendered.push(<p key={i}>{block.text}</p>);
    }
  });
  flushList("list-end");

  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-3xl px-6 py-12">
        <Link to="/" className="text-sm text-primary hover:underline">
          &larr; Back to OracyAI
        </Link>
        <h1 className="mt-4 text-3xl font-bold tracking-tight">{title}</h1>
        <div className="mt-8 space-y-4 text-sm leading-relaxed text-foreground">
          {rendered}
        </div>
      </div>
    </div>
  );
}
